var Backbone = require('backbone');

var Organization = Backbone.Model.extend({
    defaults: {
        id: undefined,
        name: '',
        object: {
            address: '',
            created: '',
            //contact: undefined
        }
    },

    urlRoot: '/api/organization',


    validate: function(attrs) {
        var errors = {};
        var hasError = false;
        if (!attrs.name) {
            errors.assignee = 'Name must be set';
            hasError = true;
        }
        if (hasError) {
            return errors;
        }
    },

    sync: function (method, model, options) {
        options.attrs = _.omit(model.attributes, 'relations');
        return Backbone.sync.call(this, method, model, options);
    }
});


module.exports = Organization;


//////////////////
// WEBPACK FOOTER
// ./app/models/organization.js
// module id = 208
// module chunks = 0